module.exports = __webpack_public_path__ + "img/pin-tesco.8fcc50d5.svg";